export interface CallToActionEndorsementProps {
  iconPath: string;
  label: string;
}

const CallToActionEndorsements: CallToActionEndorsementProps[] = [
  {
    iconPath: "/dashboard/call-to-action/shield.svg",
    label: "Bank-Level Encryption",
  },
  {
    iconPath: "/dashboard/call-to-action/check.svg",
    label: "SSL secured transactions",
  },
  {
    iconPath: "/dashboard/call-to-action/lock.svg",
    label: "Your information stays private",
  },
];

export const CallToActionEndorsement = ({
  iconPath,
  label,
}: CallToActionEndorsementProps) => {
  return (
    <div className="bg-white shadow-md text-center rounded-md px-2 py-8 md:py-6 md:px-2 mb-6 w-full xl:max-w-md mx-auto flex flex-col gap-4 md:gap-4">
      <img src={iconPath} className="h-20" />
      <p className="text-2xl font-semibold">{label}</p>
    </div>
  );
};

export const Endorsements = () => {
  return (
    <div className="w-full grid grid-cols-1 xl:grid-cols-3 py-[5%]  px-[5%] gap-8">
      {CallToActionEndorsements.map((endorsement) => (
        <CallToActionEndorsement key={endorsement.label} {...endorsement} />
      ))}
    </div>
  );
};
